import {createAction, createAsyncAction} from 'typesafe-actions'
import {Entity, ID, PayloadType} from '../../../types/UtilityTypes'
import {PartialTask, ServerTask, Task, TaskListQuery} from '../../../responses/tasks'
import {Comment} from '../../../responses/comments'

export const taskActions = {
    startUpdate: createAction('@DATA_TASK/START_UPDATE')<Task>(),
    startCreate: createAction('@DATA_TASK/START_CREATE')<{objectId: ID}>(),
    startAppend: createAction('@DATA_TASK/START_APPEND')<{objectId: ID, parentId: ID}>(),
    startDelete: createAction('@DATA_TASK/START_DELETE')<{task: Task, message: string}>(),
    cancelEdit: createAction('@DATA_TASK/CANCEL_EDIT')(),
    get: createAsyncAction(
        '@DATA_TASK/GET_REQUEST',
        '@DATA_TASK/GET_SUCCESS',
        '@DATA_TASK/GET_FAILURE',
    )<ID, Required<ServerTask>, void>(),
    parents: createAsyncAction(
        '@DATA_TASK/PARENTS_REQUEST',
        '@DATA_TASK/PARENTS_SUCCESS',
        '@DATA_TASK/PARENTS_FAILURE',
    )<{ objectId: ID, query?: TaskListQuery }, { objectId: ID, tasks: ServerTask[] }, { objectId: ID }>(),
    requested: createAsyncAction(
        '@DATA_TASK/REQUESTED_REQUEST',
        '@DATA_TASK/REQUESTED_SUCCESS',
        '@DATA_TASK/REQUESTED_FAILURE'
    )<undefined, ServerTask[], void>(),
    create: createAsyncAction(
        '@DATA_TASK/CREATE_REQUEST',
        '@DATA_TASK/CREATE_SUCCESS',
        '@DATA_TASK/CREATE_FAILURE',
    )<{ objectId: ID, parentId?: ID, task: PartialTask }, [ServerTask, PayloadType], void>(),
    update: createAsyncAction(
        '@DATA_TASK/UPDATE_REQUEST',
        '@DATA_TASK/UPDATE_SUCCESS',
        '@DATA/UPDATE_FAILURE',
    )<PartialTask & Entity, [ServerTask, PayloadType], void>(),
    _delete: createAction('@DATA_TASK/DELETE')<{
        task: ID,
        children: ID[]
    }>(),
    remove: createAsyncAction(
        '@DATA_TASK/REMOVE_REQUEST',
        '@DATA_TASK/REMOVE_SUCCESS',
        '@DATA_TASK/REMOVE_FAILURE',
    )<undefined, ID, void>(),
    user: createAsyncAction(
        '@DATA_TASK/USER_REQUEST',
        '@DATA_TASK/USER_SUCCESS',
        '@DATA_TASK/USER_FAILURE',
    )<ID, { userId: ID, tasks: ServerTask[] }, undefined>(),
    comments: createAsyncAction(
        '@DATA_TASK/COMMENTS_REQUEST',
        '@DATA_TASK/COMMENTS_SUCCESS',
        '@DATA_TASK/COMMENTS_FAILURE',
    )<{taskId: ID, resulted: boolean}, {taskId: ID, resulted: boolean, comments: Comment[]}, void>(),
    waybill: createAsyncAction(
        '@DATA_TASK/WAYBILL_REQUEST',
        '@DATA_TASK/WAYBILL_SUCCESS',
        '@DATA_TASK/WAYBILL_FAILURE',
    )<{id: any},any,void>()// eslint-disable-line
}